module.exports = __webpack_public_path__ + "static/org-logo-792ddcdfecff9e123bb805caed8b312b.svg";